import {
  getUserClients,
  getUsers,
  InsertUser,
  getDetails,
  UpdateDetails,
  ChangePoints,
  CreditedPoints,
  ReportsPageResult,
  TransactionDropDown,
  LockStatusUpdate,
  emailPassword,
} from "../../../api/divvy-manageUsers";

const manageUsers = {
  namespaced: true,
  state: () => ({
    clientList: [],
    searchTerm: "",
    userType: 0,
    lockStatusType: 0,
    clients: [],
    pageNumber: 1,
    pageSize: 100,
    sortField: "",
    sortOrder: "",
    result: [],
    totalRecords: 0,
    totalPoints: 0,
    adminList: [],

    // edit screen
    email: "",
    userName: "",
    password: "",
    startingPoints: 0,
    singleItem: false,
    showTransaction: false,
    superAdminAce: false,
    code: "",
    selectClient: null,
    selectClientOptions: [],
    jobTitle: "",
    firstName: "",
    middleName: "",
    lastName: "",
    addressAtn: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    dayPhone: "",
    eveningPhone: "",
    socialSecurityNo: "",
    selectAdmin: 0,
    selectAdminList: [],
    joiningDate: "",
    birthDay: "",
    birthYear: "",

    // update points
    updatePointsResult: null,
    creditPointsResult: null,
    reportspageResult: null,
    transactionDropDownResult: [],
  }),

  getters: {
    // main screen
    getClientList: (state) => {
      return state.clientList;
    },
    getSearchTerm: (state) => {
      return state.searchTerm;
    },
    getUserType: (state) => {
      return state.userType;
    },
    getLockStatusType: (state) => {
      return state.lockStatusType;
    },
    getClients: (state) => {
      return state.clients;
    },
    getPageNumber: (state) => {
      return state.pageNumber;
    },
    getPageSize: (state) => {
      return state.pageSize;
    },
    getSortField: (state) => {
      return state.sortField;
    },
    getSortOrders: (state) => {
      return state.sortOrder;
    },
    getResult: (state) => {
      return state.result;
    },
    getTotalRecords: (state) => {
      return state.totalRecords;
    },
    getTotalPoints: (state) => {
      return state.totalPoints;
    },
    // getSelectedRecordCount: (state) => {
    //   return state.selectedRecordCount;
    // },
    getAdminList: (state) => {
      return state.adminList;
    },

    // edit screen
    // getEmail: (state) => {
    //   return state.email;
    // },
    // getUserName: (state) => {
    //   return state.userName;
    // },
    // getPassword: (state) => {
    //   return state.password;
    // },
    // getStartingPoints: (state) => {
    //   return state.startingPoints;
    // },
    // getSuperAdminAce: (state) => {
    //   return state.superAdminAce;
    // },
    // getCode: (state) => {
    //   return state.code;
    // },
    // getSelectClient: (state) => {
    //   return state.selectClient;
    // },
    // getSelectClientOptions: (state) => {
    //   return state.selectClientOptions;
    // },
    // getJobTitle: (state) => {
    //   return state.jobTitle;
    // },
    // getFirstName: (state) => {
    //   return state.firstName;
    // },
    // getMiddleName: (state) => {
    //   return state.middleName;
    // },
    // getLastName: (state) => {
    //   return state.lastName;
    // },
    // getAddressAtn: (state) => {
    //   return state.addressAtn;
    // },
    // getAddress: (state) => {
    //   return state.address;
    // },
    // getCity: (state) => {
    //   return state.city;
    // },
    // getState: (state) => {
    //   return state.state;
    // },
    // getZipCode: (state) => {
    //   return state.zipCode;
    // },
    // getDayPhone: (state) => {
    //   return state.dayPhone;
    // },
    // getEveningPhone: (state) => {
    //   return state.eveningPhone;
    // },
    // getSocialSecurityNo: (state) => {
    //   return state.socialSecurityNo;
    // },
    // getSelectAdmin: (state) => {
    //   return state.selectAdmin;
    // },
    // getSelectAdminList: (state) => {
    //   return state.selectAdminList;
    // },
    // getJoiningDate: (state) => {
    //   return state.joiningDate;
    // },
    // getBirthDay: (state) => {
    //   return state.birthDay;
    // },
    // getBirthYear: (state) => {
    //   return state.birthYear;
    // },

    // points screen
    getUpdatePointsResult: (state) => {
      return state.updatePointsResult;
    },
    getCreditPointsResult: (state) => {
      return state.creditPointsResult;
    },
    getReportspageResult: (state) => {
      return state.reportspageResult;
    },
    getTransactionDropDownResult: (state) => {
      return state.transactionDropDownResult;
    },
  },

  actions: {
    emailPassword({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        emailPassword(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log("error while emailPassword store" + err);
          });
      });
    },

    // MAIN SCREEN
    // for fetching client list
    fetchGetUserClients({ commit }) {
      return new Promise((resolve, reject) => {
        console.log(
          "hello from divvyAdmin < manageUsers < fetchGetUserClients"
        );
        getUserClients()
          .then((api_data) => {
            commit("SET_CLIENT_LIST", api_data);
          })
          .catch(() => {
            console.log(
              "error from from divvyAdmin < manageUsers < fetchGetUserClients"
            );
          });
      });
    },

    // MAIN SCREEN
    // for fetching table records
    // For pagination on table records
    fetchGetUsers({ state, commit }) {
      return new Promise((resolve, reject) => {
        console.log("hello from divvyAdmin < manageUsers < fetchGetUsers");
        const payload = {
          searchTerm: state.searchTerm,
          userType: state.userType,
          lockStatusType: state.lockStatusType,
          clients: state.clients,
          pageNumber: state.pageNumber,
          pageSize: state.pageSize,
          sortField: state.sortField,
          sortOrder: state.sortOrder,
        };
        getUsers(payload)
          .then((api_data) => {
            console.log(api_data);
            commit("SET_RESULT", api_data.Result);
            commit("SET_PAGE_NUMBER", api_data.pageNumber);
            commit("SET_PAGE_SIZE", api_data.pageSize);
            commit("SET_TOTAL_RECORDS", api_data.totalRecords);
            commit("SET_TOTAL_POINTS", api_data.totalPoints);
            // commit("SET_SELECTED_RECORD_COUNT", api_data.selectedRecordCount);
            commit("SET_SORT_FIELD", api_data.sortField);
            commit("SET_SORT_ORDER", api_data.sortOrder);
          })
          .catch(() => {
            console.log(
              "error from from divvyAdmin < manageUsers < fetchGetUsers"
            );
          });
      });
    },

    setFormData({ commit }, payload) {
      commit("SET_CLIENTS", payload.clients);
      commit("SET_USER_TYPE", payload.userType);
      commit("SET_LOCK_STATUS_TYPE", payload.lockStatusType);
      commit("SET_SEARCHTERM", payload.searchTerm);
    },
    setPageSize({ commit }, payload) {
      commit("SET_PAGE_SIZE", payload);
    },
    setSortFieldAndOrder({ commit }, payload) {
      commit("SET_SORT_FIELD", payload.sortField);
      commit("SET_SORT_ORDER", payload.sortOrder);
    },
    setPageNumber({ commit }, payload) {
      commit("SET_PAGE_NUMBER", payload);
    },

    // Update lock status of user
    setLockStatus({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log("lock status payload" + payload);
        LockStatusUpdate(payload)
          .then(() => {
            resolve();
            console.log("lock status updated");
          })
          .catch((err) => {
            console.log("error while updating lock status" + err);
          });
      });
    },

    // // MAIN SCREEN

    // fetchGetUsersPaginate({ commit }, payload) {
    //   return new Promise((resolve, reject) => {
    //     console.log(
    //       "hello from divvyAdmin < manageUsers < fetchGetUsers < pagination"
    //     );
    //     getUsers(payload)
    //       .then((api_data) => {
    //         console.log(api_data);
    //         commit("SET_RESULT", api_data.Result);
    //         commit("SET_PAGE_NUMBER", api_data.pageNumber);
    //         commit("SET_PAGE_SIZE", api_data.pageSize);
    //         commit("SET_TOTAL_RECORDS", api_data.totalRecords);
    //         commit("SET_TOTAL_POINTS", api_data.totalPoints);
    //         // commit("SET_SELECTED_RECORD_COUNT", api_data.selectedRecordCount);
    //         commit("SET_SORT_FIELD", api_data.sortField);
    //         commit("SET_SORT_ORDER", api_data.sortOrder);
    //       })
    //       .catch(() => {
    //         console.log(
    //           "error from from divvyAdmin < manageUsers < fetchGetUsers < pagination"
    //         );
    //       });
    //   });
    // },

    // ADD USER SCREEN
    // For Add User Functionality
    addUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        console.log(params);
        InsertUser(params)
          .then((userId) => {
            resolve(userId);
          })
          .catch(() => {
            console.log("error while adding user");
          });
      });
    },

    // EDIT SCREEN
    // For prefilling user details
    fetchExistingDetails({ commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log("hello from divvyAdmin < manageUsers < editUser");
        getDetails(payload)
          .then((api_data) => {
            console.log("hello fetchExistingDetails");
            resolve(api_data);
          })
          .catch(() => {
            console.log("error from divvyAdmin < manageUsers < editUser");
          });
      });
    },

    // EDIT SCREEN
    // For updating user details
    updateUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log(payload);
        UpdateDetails(payload)
          .then((userId) => {
            resolve(userId);
          })
          .catch((e) => {
            console.log(`${e} : error while updating user`);
          });
      });
    },

    // POINTS SCREEN
    // For updating user points
    setChangedPoints({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        ChangePoints(payload)
          .then((result) => {
            resolve(result);
            state.updatePointsResult = result;
            console.log(`user points updated`);
          })
          .catch((err) => {
            console.log(`${err} occoured while updating points`);
          });
      });
    },
    setCreditedPoints({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        CreditedPoints(payload)
          .then((result) => {
            resolve(result);
            console.log(result);
            state.creditPointsResult = result;
            console.log(`user points credited`);
          })
          .catch((err) => {
            console.log(`${err} occoured while crediting points`);
          });
      });
    },

    // REPORTS SCREEN
    // For getting user reports
    setReportResults({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        ReportsPageResult(params)
          .then((api_data) => {
            resolve(api_data);
            console.log(api_data);
            commit("SET_REPORT_RESULTS", api_data);
          })
          .catch((err) => {
            console.log(`${err} occoured while getting ser report`);
          });
      });
    },

    // For getting transaction dropdown
    setTransactionDropDownResult({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        TransactionDropDown(params)
          .then((result) => {
            resolve(result);
            console.log("Transaction DropDown : " + result);
            state.transactionDropDownResult = result;
          })
          .catch((err) => {
            console.log(
              "Error while getting transaction dropdown results" + err
            );
          });
      });
    },
  },

  mutations: {
    // main screen
    SET_CLIENT_LIST: (state, clientList) => {
      state.clientList = clientList ? clientList : [];
    },
    SET_RESULT: (state, result) => {
      state.result = result ? result : [];
    },
    SET_SEARCHTERM: (state, searchTerm) => {
      state.searchTerm = searchTerm ? searchTerm : "";
    },
    SET_USER_TYPE: (state, userType) => {
      state.userType = userType;
    },
    SET_LOCK_STATUS_TYPE: (state, lockStatusType) => {
      state.lockStatusType = lockStatusType;
    },
    SET_CLIENTS: (state, clients) => {
      state.clients = clients ? clients : [];
    },
    SET_PAGE_NUMBER: (state, pageNumber) => {
      state.pageNumber = pageNumber ? pageNumber : 1;
    },
    SET_PAGE_SIZE: (state, pageSize) => {
      state.pageSize = pageSize ? pageSize : 100;
    },
    SET_TOTAL_RECORDS: (state, totalRecords) => {
      state.totalRecords = totalRecords ? totalRecords : 0;
    },
    SET_TOTAL_POINTS: (state, totalPoints) => {
      state.totalPoints = totalPoints ? totalPoints : 0;
    },
    // SET_SELECTED_RECORD_COUNT: (state, selectedRecordCount) => {
    //   state.selectedRecordCount = selectedRecordCount
    //     ? selectedRecordCount
    //     : 100;
    // },
    SET_ADMIN_LIST: (state, adminList) => {
      state.adminList = adminList ? adminList : [];
    },
    SET_SORT_FIELD: (state, sortField) => {
      state.sortField = sortField;
    },
    SET_SORT_ORDER: (state, sortOrder) => {
      state.sortOrder = sortOrder;
    },
    // main screen

    // edit screen
    // GET_EMAIL: (state, email) => {
    //   state.email = email ? email : "";
    // },
    // GET_USERNAME: (state, userName) => {
    //   state.userName = userName ? userName : "";
    // },
    // GET_PASSWORD: (state, password) => {
    //   state.password = password ? password : "";
    // },
    // GET_STARTING_POINTS: (state, startingPoints) => {
    //   state.startingPoints = startingPoints;
    // },
    // GET_SINGLEITEM: (state, singleItem) => {
    //   state.singleItem = singleItem ? singleItem : false;
    // },
    // GET_SHOWTRANSACTION: (state, showTransaction) => {
    //   state.showTransaction = showTransaction ? showTransaction : false;
    // },
    // GET_SUPERADMINACE: (state, superAdminAce) => {
    //   state.superAdminAce = superAdminAce ? superAdminAce : false;
    // },
    // GET_CODE: (state, code) => {
    //   state.code = code ? code : "";
    // },
    // GET_SELECT_CLIENT: (state, selectClient) => {
    //   state.selectClient = selectClient ? selectClient : null;
    // },
    // GET_CLIENT_OPTIONS: (state, selectClientOptions) => {
    //   state.selectClientOptions = selectClientOptions
    //     ? selectClientOptions
    //     : [];
    // },
    // GET_JOB_TITLE: (state, jobTitle) => {
    //   state.jobTitle = jobTitle ? jobTitle : "";
    // },
    // GET_FIRST_NAME: (state, firstName) => {
    //   state.firstName = firstName ? firstName : "";
    // },
    // GET_MIDDLE_NAME: (state, middleName) => {
    //   state.middleName = middleName ? middleName : "";
    // },
    // GET_LAST_NAME: (state, lastName) => {
    //   state.lastName = lastName ? lastName : "";
    // },
    // GET_ADDRESSATN: (state, addressAtn) => {
    //   state.addressAtn = addressAtn ? addressAtn : "";
    // },
    // GET_ADDRESS: (state, address) => {
    //   state.address = address ? address : "";
    // },
    // GET_CITY: (state, city) => {
    //   state.city = city ? city : "";
    // },
    // GET_STATE: (state, stateofRes) => {
    //   state.stateofRes = stateofRes ? stateofRes : "";
    // },
    // GET_ZIPCODE: (state, zipCode) => {
    //   state.zipCode = zipCode ? zipCode : "";
    // },
    // GET_DAYPHONE: (state, dayPhone) => {
    //   state.dayPhone = dayPhone ? dayPhone : "";
    // },
    // GET_EVENINGPHONE: (state, eveningPhone) => {
    //   state.eveningPhone = eveningPhone ? eveningPhone : "";
    // },
    // GET_SSN: (state, socialSecurityNo) => {
    //   state.socialSecurityNo = socialSecurityNo ? socialSecurityNo : "";
    // },
    // GET_SELECTADMIN: (state, selectAdmin) => {
    //   state.selectAdmin = selectAdmin;
    // },
    // GET_ADMINLIST: (state, selectAdminList) => {
    //   state.selectAdminList = selectAdminList ? selectAdminList : [];
    // },
    // GET_JOINING_DATE: (state, joiningDate) => {
    //   state.joiningDate = joiningDate ? joiningDate : "";
    // },
    // GET_BIRTHDAY: (state, birthDay) => {
    //   state.birthDay = birthDay ? birthDay : "";
    // },
    // GET_BIRTHYEAR: (state, birthYear) => {
    //   state.birthYear = birthYear ? birthYear : "";
    // },
    // // edit screen
    SET_REPORT_RESULTS: (state, data) => {
      state.reportspageResult = data;
    },
  },
};

export default manageUsers;
